import { Link, useActionData } from 'react-router-dom';
import { UnlockAccount } from '../repo/AccountsRepo';

export default function AccountUnlock() {
  const reponseData = useActionData()

  return (
    <>
      {reponseData && reponseData.errors && (
        <p>{reponseData.errors.detail}</p>
      )}

      {!reponseData && (
        <section>
          <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0 w-full lg:w-1/2">
            <h1 className="flex items-center lg:mt-24 mb-6 text-2xl font-semibold text-gray-900">
              Desbloqueio de conta
            </h1>

            <div className="flex items-center p-4 mt-8 mb-4 text-sm text-green-800 border border-green-300 rounded-lg bg-green-50 w-full" role="alert">
              <svg className="shrink-0 inline w-4 h-4 me-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
              </svg>
              <span className="sr-only">Info</span>
              <div>
                Sua conta foi desbloqueada com sucesso.
              </div>
            </div>

            <p className='pt-10'>Clique <Link to="/sign_in" className='font-medium text-green-600 hover:underline'>aqui</Link> para entrar.</p>
          </div>
        </section>
      )}
    </>
  )
}

export async function unlockAccount({request}) {
  const searchParams = new URL(request.url).searchParams
  const token = searchParams.get('token') || ''

  return await UnlockAccount(token)
}
